import React from 'react';

import * as St from './styles';

type IDocumentItem = {
  title: string;
  value: string;
};

interface ITableOCR {
  data: Partial<IDocumentItem[]>;
}
const TableOCR: React.FC<ITableOCR> = ({ data }) => {
  return (
    <St.Table>
      <St.TableHead>
        <St.TableRow>
          <St.TableHeader>Descrição</St.TableHeader>
          <St.TableHeader>Valor</St.TableHeader>
        </St.TableRow>
      </St.TableHead>
      <St.TableBody>
        {data?.map((item, index) => (
          <St.TableRow key={index}>
            <St.TableCell>{item.title}</St.TableCell>
            <St.TableCell>{item.value}</St.TableCell>
          </St.TableRow>
        ))}
      </St.TableBody>
    </St.Table>
  );
};

export default TableOCR;
